export enum TaskType {
  NewChat,
  Invitation,
  DeleteAccount
}

export namespace TaskType {
  export function toString(type: TaskType) {
    switch (type) {
      case TaskType.NewChat:
        return 'NEW_CHAT'
      case TaskType.Invitation:
        return 'INVITATION'
      case TaskType.DeleteAccount:
        return 'DELETE_USER'
      default:
        return 'UNKNOWN'
    }
  }
}

export class Task {
  public type:      TaskType
  public sourceUid: string
  public targetUid: string
  public chatId:    string

  public static createDeleteAccountTask(uid: string) {
    const task = new Task()
    task.type = TaskType.DeleteAccount
    task.targetUid = uid
    task.sourceUid = null
    task.chatId = null

    return task
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/core/tasks/task.model.ts